// localStorage can throw (private mode, blocked storage, some TV browsers). Never let it crash the app.
export const storage = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      /* ignore */
    }
  },
  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  },
  getJson<T>(key: string): T | null {
    const raw = storage.get(key);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  },
  setJson(key: string, value: unknown): void {
    storage.set(key, JSON.stringify(value));
  },
};

export const keys = {
  authToken: 'masa.auth',
  device: 'masa.device',
  hostToken: (sessionId: string) => `masa.host.${sessionId}`,
  player: (code: string) => `masa.player.${code.toUpperCase()}`,
  /** Token of this TV as an extra screen of a room. */
  display: (code: string) => `masa.display.${code.toUpperCase()}`,
  /** Room code of the lobby this phone is waiting in (kept while browsing other pages). */
  activeRoom: 'masa.activeRoom',
  lastName: 'masa.name',
  lastAvatar: 'masa.avatar',
  /** '0' when this device's game sound effects are switched off. */
  sound: 'masa.sound',
};
